export default __webpack_public_path__ + "static/media/bn.d.ts.59bdef56.map";